import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(() =>
    import("@lexus.com/ui/dist/_nextgen/components/SmartSections")
);

const ComponentEditConfig = {
    emptyLabel: "Smart Sections",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const transformData = (props) => ({
    component: "SmartSections",
    props: {
        ...props,
        superTitle: props?.superTitle,
        title: props?.title,
        textColor: props?.textColor,
        lineColor: props?.lineColor,
        theme: props?.theme,
        tabs: props?.tabs,
        cta: props?.cta,
        ctas: props?.ctas,
        hideTabs: props?.hideTabs,
        renderArrows: props?.arrowBackgroundColor || props?.arrowColor,
        arrowBackgroundColor: props?.arrowBackgroundColor,
        arrowColor: props?.arrowColor
    },
});

const SmartSections = (props) => {
    const data = transformData(props);
    return <Component {...data?.props} />;
};

export default withAemIntegration("lexus/components/content/smart-sections")(
    SmartSections,
    ComponentEditConfig
);
